import { useEffect, useRef } from 'react';

const targetEvents = ['touchstart', 'mousedown'];

export const useClickAway = (handler) => {
    const targetRef = useRef(null);
    const handlerRef = useRef(handler);

    useEffect(() => {
        handlerRef.current = handler;
    }, [handler]);

    const handleEvent = (e) => {
        console.log('handleEvent', e.target, targetRef.current);
        if (!targetRef.current?.contains(e.target)) {
            handlerRef.current(e);
        }
    };

    useEffect(() => {
        targetEvents.forEach((event) => {
            document.addEventListener(event, handleEvent);
        });

        return () => {
            targetEvents.forEach((event) => {
                document.removeEventListener(event, handleEvent);
            });
        };
    }, [targetRef]);

    return targetRef;
};
